import { IGQLApiError } from "../api.types"
import { ApiErrorCode, errorCodesWithMessages } from "../constants/errorCodes"
import {
    DEFAULT_GQL_SERVER_ERROR,
    ERROR_500_TEXT,
} from "../constants/errorMessages"
import { HttpApiError } from "../errors/HttpApiError"

const parseHttpApiError = (httpApiErrors: IGQLApiError[]): never => {
    const parsedErrors: string[] = (Array.isArray(httpApiErrors))
        ? httpApiErrors
            .filter((error: IGQLApiError) => !error.message.includes(DEFAULT_GQL_SERVER_ERROR))
            .map((error: IGQLApiError) => {
                if (error?.code === ApiErrorCode.ReferrerNotFound) {
                    return error?.message
                } else {
                    return errorCodesWithMessages[error?.code as keyof typeof errorCodesWithMessages] ?? ERROR_500_TEXT
                }
            })
        : [ERROR_500_TEXT]
    throw new HttpApiError(parsedErrors)
}

export default parseHttpApiError
